import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, IconButton } from '@chakra-ui/react';
import { EComponentsFamilyClass, useT } from '@progress-fe/core';
import { Svg } from '../../../../base';
import { VirtualTable } from '../../../../tables';
import { Input, Select } from '../../../../inputs';
const PureComponentsFC = ({ favorites, components, selectedComponents, onAddComponent, onDeleteComponent, onAddAllComponents, onDeleteAllComponents, onToggleFavorite, tableSx }) => {
    const [query, setQuery] = useState('');
    const [selectedFamilyType, setSelectedFamilyType] = useState(EComponentsFamilyClass.ALL);
    const { t } = useT();
    const pureChemicalFamilyTypeOptions = [
        { value: EComponentsFamilyClass.ALL, label: 'Все классы' },
        { value: EComponentsFamilyClass.HYDROCARBONS, label: 'Углеводороды' },
        { value: EComponentsFamilyClass.HALOGENS, label: 'Галогены' },
        { value: EComponentsFamilyClass.ALCOHOLS, label: 'Спирты' },
        { value: EComponentsFamilyClass.ALDEHYDES, label: 'Альдегиды' },
        { value: EComponentsFamilyClass.HYDROCARBON_ACIDS, label: 'Углевод. кистоты' },
        { value: EComponentsFamilyClass.KETONES, label: 'Кетоны' },
        { value: EComponentsFamilyClass.NON_ORGANIC, label: 'Неогранические' },
        { value: EComponentsFamilyClass.PHENOLS, label: 'Фенолы' },
        { value: EComponentsFamilyClass.SULPHUROUS, label: 'Серосодержащие' },
        { value: EComponentsFamilyClass.AMINES, label: 'Амины' },
        { value: EComponentsFamilyClass.COMPOUND_ETHER, label: 'Cложные эфиры' },
        { value: EComponentsFamilyClass.SIMPLE_ETHER, label: 'Простые эфиры' },
        { value: EComponentsFamilyClass.NITRILES, label: 'Нитрилы' },
        { value: EComponentsFamilyClass.OTHERS, label: 'Прочие' }
    ];
    const columns = [
        { name: t('fields.name'), align: 'left' },
        { name: t('fields.formula'), align: 'left' },
        { name: t('fields.structure'), align: 'left' },
        {
            name: '',
            width: '24px',
            columnTemplate: '24px',
            render: (id) => {
                if (!id) {
                    return undefined;
                }
                const isFavorite = favorites.has(id);
                return (onToggleFavorite && (_jsx(IconButton, { size: "2sm", "aria-label": "", variant: "transparent", icon: _jsx(Svg, { size: "s12", name: isFavorite ? 'FavoriteOn' : 'Favorite' }), onClick: () => onToggleFavorite(id), opacity: isFavorite ? 1 : 0, _groupHover: { opacity: !isFavorite ? 1 : undefined } })));
            }
        }
    ];
    const filteredOptionsByName = components.filter((opt) => opt.name.toLowerCase().includes(query.toLowerCase()) ||
        opt.formula?.toLowerCase().includes(query.toLowerCase()));
    const filteredOptionsByNameAndClass = filteredOptionsByName.filter((opt) => selectedFamilyType === EComponentsFamilyClass.ALL || selectedFamilyType === opt.family);
    const rows = filteredOptionsByNameAndClass.map((opt) => ({
        key: opt.uuid,
        values: [opt.name, opt.formula || '', opt.structure || '', opt.uuid],
        isSelected: selectedComponents.has(opt.uuid),
        isDisabled: false
    }));
    return (_jsxs(Grid, { templateRows: "auto 1fr", gap: "8px", children: [_jsxs(Grid, { gridTemplateColumns: "1fr 140px", gap: "8px", children: [_jsx(Input, { name: "search", size: "xs", variant: "outline", value: query, placeholder: t('actions.search'), onChange: setQuery }), _jsx(Select, { name: "chemical_class", options: pureChemicalFamilyTypeOptions, value: pureChemicalFamilyTypeOptions.find((opt) => opt.value === selectedFamilyType), onChange: (option) => setSelectedFamilyType(option.value) })] }), _jsx(VirtualTable, { rows: rows, isCheckboxShown: true, columns: columns, noItemsTitle: t('components.no'), tableSx: tableSx, onSelectAll: onAddAllComponents, onUnselectAll: onDeleteAllComponents, onSelect: onAddComponent, onUnselect: onDeleteComponent })] }));
};
export const PureComponents = observer(PureComponentsFC);
//# sourceMappingURL=PureComponents.js.map